import React from "react";
import { FormattedMessage } from "react-intl";
import { ErrorAlert } from "theme/components/molecules/Alert";
import { H2 } from "theme/components/atoms/Typography/Heading";
import { BodyParagraph } from "theme/components/atoms/Typography/Body";

const DefaultFallbackComponent = ({ error }) => {
  return (
    <ErrorAlert>
      <H2>
        <FormattedMessage
          id="components.helpers.ErrorBoundary.DefaultFallbackComponent.title"
          defaultMessage="An error occured."
        />
      </H2>
      <BodyParagraph>{error.toString()}</BodyParagraph>
    </ErrorAlert>
  );
};

export default DefaultFallbackComponent;
